import { Component } from '@angular/core';
import { NavController } from 'ionic-angular';

import { MessageviewPage } from '../../pages/messageview/messageview';

import { UserData } from '../../providers/user-data';

import { Http } from '@angular/http';

import 'rxjs/add/operator/map';


@Component({
  templateUrl: 'build/pages/message/message.html',
})
export class MessagePage {

jobs: Array<any>;

 username: string;

  constructor(private navCtrl: NavController,
    public user: UserData,
    private http: Http
  ) {

 this.loadjobs();
  }


   loadjobs() {

  this.user.getUsername().then((username) => {
    this.username = username;
 var url = 'http://letpco.co.uk/api/v1/msg?authkey='+this.username;

          this.http.get(url).subscribe(res => {

 this.jobs = res.json().data;
        
     
      });

 return 'hi';

  });
    }

   
  itemTapped(event, job) {
        this.navCtrl.push(MessageviewPage, job);
    }





}
